module.exports = __webpack_public_path__ + "img/cashier_bg@2x.07c7723f.png";